// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_9e1425b4d3--checkbox--V8SSh","label":"_9e1425b4d3--label--spcLW","box":"_9e1425b4d3--box--SMS_5","hasLabel":"_9e1425b4d3--hasLabel--TalIs"};